import { BadgePreset, Preset } from './types'

const BADGE_PRESETS: { [preset in Preset]: BadgePreset } = {
  'smart-account': {
    text: 'Smart Account',
    type: 'success',
    tooltipText:
      'Smart Accounts unlock the full potential of Ethereum and EVM networks, offering advanced features like paying gas fees in stablecoins, simulating transaction outcomes, and batching multiple actions into a single transaction.'
  },
  'view-only': {
    text: 'View-only',
    type: 'info',
    tooltipText:
      'The "View-only" account is imported without signer keys, meaning you can see its balances, connect it with apps, simulate transactions, and more, but you cannot control it or sign transactions or messages.'
  },
  'ambire-v1': {
    text: 'ZKX v1',
    type: 'info',
    tooltipText:
      'Smart Accounts created with the Web or Mobile platforms of ZKX Wallet. You can sign transactions (single and batched ones), connect with apps, and more, but cannot utilize all the features and functionalities of the ZKX Wallet extension.'
  },
  linked: {
    text: 'Linked',
    type: 'info',
    tooltipText:
      'Smart Accounts were initially created with a given signer key, but another signer key is authorized for that account on one or more of the supported networks.'
  },
  metamask: {
    text: 'Metamask',
    type: 'warning',
    tooltipText: 'This account has a Metamask EIP-7702 delegation',
    specialType: 'metamask'
  }
}

export default BADGE_PRESETS
